/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import styles from "../styles/ClipboardItem.module.scss";

const ClipboardItem = ({ card, legal, legal_commander, onAdd, onPromote, onRemove, onShow, type }) => (
  <div className={styles.decklistItemWrapper}>
    <div
      className={classNames(styles.decklistItem, {
        [styles.decklistRec]: type === "rec",
        [styles.illegal]: !legal,
      })}
      onClick={onShow}
    >
      {card.name}
    </div>
    <div className={styles.decklistItemButtons}>
      {type === "card" && legal_commander && (
        <FontAwesomeIcon className={styles.commanderButton} icon="crown" onClick={onPromote} />
      )}
      <FontAwesomeIcon icon="link" onClick={() => window.open(`/${type}s/${card.url}`, "_blank")} />
      <div className="glyphicon glyphicon-link" />
      {type === "rec" ? (
        <FontAwesomeIcon className={styles.addButton} icon="check" onClick={() => onAdd(card)} />
      ) : (
        <FontAwesomeIcon className={styles.removeButton} icon="times" onClick={() => onRemove(card.name)} />
      )}
    </div>
  </div>
);

export default ClipboardItem;
